export default __webpack_public_path__ + "static/media/shard-stigma-active.13e83887.jpg";